import { useUserGroupConfigurationQuery } from "../../graphql/__generated__";
export default function useConfigurationByUserGroupId(groupId) {
    var _a;
    const { data, loading, error } = useUserGroupConfigurationQuery({
        variables: {
            id: groupId,
        },
    });
    if (!groupId) {
        return {
            loading: false,
            error: null,
            data: {},
        };
    }
    return {
        loading,
        error: error || null,
        data: ((_a = data === null || data === void 0 ? void 0 : data.user_groups_by_pk) === null || _a === void 0 ? void 0 : _a.user_group_configuration) || {},
    };
}
//# sourceMappingURL=index.js.map